export function isEqual(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
}



// WEBPACK FOOTER //
// ./src/util/equality.js